import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

//constants
import { checkIsAdmin } from '~/redux/actions/authentication-actions';
import { ContentSpinner } from '../../ui/layout/spinner';

/**
 * Higher-order component (HOC) to wrap Restricted pages
 *
 * @export
 * @param {any} ComposedComponent
 * @returns
 */
export default function(ComposedComponent) {
	class Restricted extends Component {
		constructor(props) {
			super(props);

			this.state = {
				isLoading: true,
			};
		}
		/**
		 * When the component mounts, checks for authentication
		 *
		 * @memberof Restricted
		 */
		componentDidMount() {
			if (this.props.isAdmin && this.props.isLoggedIn) {
				this.setState({
					isLoading: false,
				});
			} 
			// else {
			// 	this.checkAuthentication();
			// }
		}

		shouldComponentUpdate() {
			return true;
		}

		/**
		 * When a url location is changed, it also checks for authentication
		 *
		 * @param {any} nextProps
		 * @memberof Restricted
		 */
		componentDidUpdate(prevProps) {
			// If comes from a different route in the app
			if (prevProps.location !== this.props.location) {
				this.checkAuthentication();
			} else {
			}

			if (prevProps.isAdmin !== this.props.isAdmin) {
				this.setState({
					isLoading: false,
				});
			}
		}

		/**
		 * Verifies if t he user is signed in or not.
		 * If not, redirects him to the login page.
		 *
		 * @param {any} params
		 * @memberof Restricted
		 */
		checkAuthentication() {
			this.props.dispatch(checkIsAdmin());
		}
		render() {
			const { isLoading } = this.state;
			const { isLoggedIn, isAdmin } = this.props;

			if (isLoading) {
				return <ContentSpinner />;
			} else {
				if (isLoggedIn) {
					if (isAdmin) {
						return <ComposedComponent {...this.props} />;
					}
				} else {
					return null;
				}
			}
		}
	}

	function mapStateToProps(state) {
		return {
			isLoggedIn: state.authentication.isLoggedIn,
			isAdmin: state.authentication.profile.admin,
		};
	}

	// PropTypes

	Restricted.defaultProps = {
		isLoggedIn: false,
		isAdmin: false,
	};

	Restricted.propTypes = {
		isLoggedIn: PropTypes.bool,
		isAdmin: PropTypes.bool,
	};

	return withRouter(connect(mapStateToProps)(Restricted));
}



// WEBPACK FOOTER //
// ./src/components/general/restricted/restricted.jsx